export default "__VITE_ASSET__C0MH1pN9__"